import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext.jsx';

// Простой вход для встроенной карты (minibrowser АРМ): логин/пароль сервисной
// учётки. После входа токен запоминается в этом браузере — повторно не вводить.
export default function EmbedLogin() {
  const { embedLogin } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await embedLogin(email.trim(), password);
    } catch (err) {
      const code = err.response?.data?.error || err.message;
      setError(code === 'invalid_credentials' ? 'Неверный логин или пароль'
        : code === 'not_service_account' ? 'Эта учётка не для рабочего места'
        : code === 'account_disabled' ? 'Учётка отключена'
        : code === 'account_locked' ? 'Учётка временно заблокирована'
        : code);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="embed-login">
      <form className="embed-login-card" onSubmit={submit}>
        <h2>Вход рабочего места</h2>
        <p className="muted small">Введите логин и пароль учётки этого АРМ (один раз).</p>
        <input type="text" placeholder="Логин (email)" value={email} onChange={(e) => setEmail(e.target.value)} disabled={busy} autoFocus />
        <input type="password" placeholder="Пароль" value={password} onChange={(e) => setPassword(e.target.value)} disabled={busy} />
        {error && <div className="auth-error">{error}</div>}
        <button type="submit" disabled={busy}>{busy ? 'Входим…' : 'Войти'}</button>
      </form>
    </div>
  );
}
